/**
 * ContactForm.js - Contact/support form for logged-in users
 */

import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import * as api from '../services/api';
import './ContactForm.css';

function ContactForm({ onBack }) {
  const { user } = useAuth();
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setSending(true);
    setError('');
    try {
      await api.sendContact(user?.name || '', user?.email || '', message);
      setSent(true);
      setMessage('');
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-card">
        <h2>Contact Us</h2>
        <p className="contact-subtitle">
          Have a question, found a bug, or want to request a feature? Let us know.
        </p>

        {sent ? (
          <div className="contact-success">
            <div className="contact-success-icon">&#10003;</div>
            <h3>Message Sent</h3>
            <p>Thanks for reaching out! We'll get back to you soon.</p>
            <button onClick={() => setSent(false)} className="contact-btn">
              Send Another Message
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="contact-field">
              <label>Your Email</label>
              <input type="email" value={user?.email || ''} disabled />
            </div>
            <div className="contact-field">
              <label>Message</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Describe your issue or question..."
                rows={6}
                required
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="contact-btn" disabled={sending || !message.trim()}>
              {sending ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ContactForm;
